/**
 * Decodifica entidades HTML (como &nbsp;, &amp;, &lt;, etc)
 * e remove tags HTML de uma string
 *
 * @param {string} html - String HTML a ser decodificada
 * @returns {string} - Texto limpo sem HTML e com entidades decodificadas
 */
const decodeHtmlEntities = (html) => {
  if (!html || typeof html !== 'string') return '';

  // Cria um elemento temporário para aproveitar o parser nativo do browser
  const textarea = document.createElement('textarea');

  // Remove tags HTML primeiro
  const withoutTags = html.replace(/<\/?[^>]+(>|$)/g, '');

  // Decodifica entidades HTML
  textarea.innerHTML = withoutTags;
  const decoded = textarea.value;

  // Limpa múltiplos espaços em branco e quebras de linha
  return decoded
    .replace(/\s+/g, ' ')  // Múltiplos espaços viram um só
    .trim();
};

/**
 * Converte HTML em texto preservando estrutura de parágrafos e listas
 * Remove tags mas mantém quebras de linha
 *
 * @param {string} html - String HTML
 * @returns {string} - Texto formatado
 */
export const htmlToText = (html) => {
  if (!html || typeof html !== 'string') return '';

  const textarea = document.createElement('textarea');

  // Converte tags de bloco em quebras de linha
  const withBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<\/h[1-6]>/gi, '\n')
    .replace(/<\/?[^>]+(>|$)/g, '');  // Remove outras tags

  // Decodifica entidades HTML
  textarea.innerHTML = withBreaks;
  const decoded = textarea.value;

  // Limpa múltiplas quebras de linha mas preserva parágrafos
  return decoded
    .replace(/\n{3,}/g, '\n\n')  // Max 2 quebras seguidas
    .replace(/ +/g, ' ')          // Múltiplos espaços viram um só
    .trim();
};

export default decodeHtmlEntities;
